// extracted by mini-css-extract-plugin
module.exports = {"auth__header":"auth_auth__header__1bdU8","text":"auth_text__pVXA3","nav__button":"auth_nav__button__4urfg","quote":"auth_quote__2IdK3","quote__name":"auth_quote__name__1xU7c"};